var React = require('react');

function IconUpload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M862.8 512.2v350.9H157.7V512.2h-96V959c0 5.5 4.5 10 10 10h877c5.5 0 10-4.5 10-10V512.2h-95.9z","key":0}),React.createElement("path",{"d":"M462.8 202.1v555.7c0 5.5 4.5 10 10 10h74.8c5.5 0 10-4.5 10-10V204.4l166.6 166.5c3.9 3.9 10.2 3.9 14.1 0l34.9-34.9c3.9-3.9 3.9-10.2 0-14.1L524.2 73c-7.8-7.8-20.5-7.8-28.3 0L247 321.9c-3.9 3.9-3.9 10.2 0 14.1l33.9 33.9c3.9 3.9 10.2 3.9 14.1 0l167.8-167.8z","key":1})]);
}

IconUpload.displayName = "IconUpload";

IconUpload.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconUpload;

IconUpload.default = IconUpload;
